module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMA+9k0B/KPKfbx3a+jcUMPBMidloMY82xZ1Yx4UkgtIICB3Z4AAACUSURBVCjPpY/XDoQgEEWHplhRwbL9/v9XLiEkJPCwZj1Pc+ckU+gCddc0XV32hYJHibw/cfTrpwefMjGilUSyxZiJARV5Kgy/RTmqXL6m5fm5mzj1oJnVntK+zSaWdwAHRQ4ALtY3LNAvCjyZD3MUGqYCs0JKsQDOQEUBEDmGAHuEnAS9Ldea25oykTglCqJgBfQPX0yvDiKlloMRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/name2.png
// module id = 460
// module chunks = 0 1 2 3 4 5 6 7